import { parseISO } from 'date-fns'
import { formatInTimeZone } from 'date-fns-tz'

const TimeSegment = ({ title, date }: { title: 'Start' | 'End'; date: Date }) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', padding: '5px 20px' }}>
      <div style={{ fontSize: '12px', fontWeight: 'bold' }}>{title}</div>
      <div style={{ fontSize: '14px', fontWeight: 'bold' }}>
        {formatInTimeZone(date, 'UTC', 'd MMMM yyyy')}
      </div>
      <div style={{ fontSize: '12px' }}>
        {formatInTimeZone(date, 'UTC', 'EEEE')} at {formatInTimeZone(date, 'UTC', 'hh:mm a xx')}
      </div>
    </div>
  )
}

const EventSettingsHeader = ({ startDate, endDate }: { startDate: string; endDate: string }) => {
  const parsedStartDate = parseISO(startDate)
  const parsedEndDate = parseISO(endDate)

  return (
    <div
      style={{
        width: '100%',
        display: 'flex',
        justifyContent: 'flex-start',
        background: '#F3F3F1'
      }}
    >
      <TimeSegment title="Start" date={parsedStartDate} />
      <TimeSegment title="End" date={parsedEndDate} />
    </div>
  )
}

export default EventSettingsHeader
